<template>
  <div class="contain" style="height: 100%">
    <v-progress-linear
      fixed
      :active="loading"
      :indeterminate="true"
    ></v-progress-linear>
    <v-fade-transition>
      <v-container v-show="compiler" fluid fill-height>
        <v-row justify="center">
          <v-col style="width: 100%; max-width: 390px">
            <v-img
              lazy-src="../../../assets/images/default.png"
              :src="profile"
              contain
              height="70"
            ></v-img>
            <v-form ref="form" class="mt-7">
              <v-text-field
                v-model="curp"
                v-on:keyup.enter="signIn()"
                label="CURP"
                maxlength="18"
                outlined
                hide-details
              ></v-text-field>
              <v-text-field
                v-model="enrollment"
                v-on:keyup.enter="signIn()"
                label="Matrícula"
                maxlength="12"
                outlined
                hide-details
                class="my-4"
              ></v-text-field>
              <v-expand-transition>
                <div v-show="alert">
                  <v-alert
                    type="error"
                    transition="fade-transition"
                    outlined
                    text
                    dense
                  >
                    <div class="text-subtitle-2">{{ error }}</div>
                  </v-alert>
                </div>
              </v-expand-transition>
            </v-form>
            <v-btn
              @click="signIn()"
              color="primary"
              large
              dark
              block
              elevation="0"
            >
              <div class="text-subtitle-2 mx-3" style="text-transform: none">
                Iniciar sesión
              </div>
            </v-btn>
            <div class="text-center text-subtitle-2 text--secondary mt-6">
              <a href="http://xdr.com.mx/" target="_blank">© xdr</a> -
              {{ school }}
              <span class="text--disabled font-weight-bold">{{ version }}</span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-fade-transition>
  </div>
</template>

<script>
import endpoint from "../../../plugins/endpoint";
import auth from "../../../plugins/auth";
import settings from "../../../plugins/settings";

export default {
  name: "Auth",

  created() {
    this.main();
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  data: () => ({
    school: "",
    profile: "",
    version: "",

    curp: "",
    enrollment: "",
    show: false,

    alert: false,
    error: "",
    loading: false,
    compiler: false,
  }),

  methods: {
    // start chain
    async main() {
      this.loading = true;
      await settings.getOne(1).then((response) => {
        this.school = response.data.school;
        this.profile = endpoint.BASE_PATH + response.data.profile_image;
        this.version = endpoint.version;

        this.loading = false;
        this.compiler = true;
      });
    },

    // invoked
    async signIn() {
      if (this.curp != "" && this.curp.length == 18) {
        if (this.enrollment != "") {
          this.loading = true;

          await auth
            .signIn(false, this.curp.trim(), this.enrollment.trim())
            .then(async (response) => {
              if (response.data.status != "error") {
                auth.openSesion(response.data.token, "/alumnos");
                await auth.identity().then((response) => {
                  this.$refs.form.reset();
                  this.$router.push("/alumnos/" + response.data.directive);
                });
              } else {
                this.showAlert(response.data.info);
              }
              this.loading = false;
            });
        } else {
          this.showAlert("Matrícula vacía o inválida");
        }
      } else {
        this.showAlert("CURP vacío o inválido");
      }
    },

    showAlert(message) {
      this.error = message;
      this.alert = true;
      setTimeout(() => (this.alert = false), 3000);
    },
  },
};
</script>